import React from 'react'
import '../styles/pages/SchoolCalender.scss'
function SchoolCalender() {
    return (
        <div className='schoolCalender'>
            <div className="schcalendar">
            <table >
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Semester</th>
                        <th>Activity</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Monday 2nd August, 2021 - Tuesday 31st August, 2021 Monday </td><td>1st</td><td>Online Registration for New and Returning students (4 weeks)</td></tr>
                    <tr><td> Monday 6th September, 2021 - Saturday 11th September, 2021 </td><td>1st</td><td>Resumption &amp; Orientation for New Students (1 week)</td></tr>
                    <tr><td>Monday 13th September, 2021 </td><td>1st</td><td>Lectures Begin for 100L-400L Students</td></tr>
                    <tr><td>Monday 27lh September, 2021</td><td>1st</td><td>Lectures Begin for 500 Level Students</td></tr>
                    <tr><td>Thursday 14lh October, 2021</td><td>1st</td><td>Matriculation for New Students</td></tr>
                    <tr><td>Monday 1SI November. 2021 - Saturday 20lh November, 2021 </td><td>1st</td><td>e - Test for 100 Level and large classes (3	weeks)</td></tr>
                    <tr><td>Wednesday 15,h December 2021 - Monday 3rd January, 2022 </td><td>1st</td><td>Annual Recess</td></tr>
                    <tr><td>Monday 10th January, 2022 - Saturday 29,h January, 2022</td><td>1st</td><td>e - Exams for 100 Level and Large Classes (3weeks)</td></tr>
                    <tr><td>Monday 17lh January, 2022 - Saturday 29th January. 2022 </td><td>1st</td><td>First Semester Exams for 200L-500Level (2 weeks)</td></tr>
                    <tr><td>Monday 31st January, 2022 - Saturday 12th February, 2022 </td><td>1st</td><td>First Semester Break (2	weeks)</td></tr>
                    <tr><td>Tuesday 1st February, 2022</td><td>1st</td><td>Convocation/Founder�s	Day</td></tr>
                    <tr><td>Monday 31s' January, 2022 - Saturday 30th July, 2022</td><td>1st</td><td>SI WES for all Schools	with exception	of SAAT and SSTE students (24 weeks)
                    </td></tr>
                    <tr><td>Monday 7th March. 2022 </td><td>1st</td><td>School Boards to Consider First	Semester	Results</td></tr>
                    <tr><td>Wednesday 30th March, 2022</td><td>1st</td><td>Senate to consider First	Semester Results </td></tr>
                    <tr><td>Monday, 14lh February, 2022</td><td>2nd</td><td>Lectures begin for all students</td></tr>
                    <tr><td>Monday 4th April, 2022 - Saturday 23rd April, 2022</td><td>2nd</td><td>e-Test for 100 Level and large classes.</td></tr>
                    <tr><td>Monday 25th April,2022 - Saturday 30lh April, 2022 </td><td>2nd</td><td>Students' Union Week</td></tr>
                    <tr><td>Monday 6lh June, 2022 - Saturday 25th June, 2022</td><td>2nd</td><td>e-Exams for 100 Level and large classes</td></tr>
                    <tr><td>Monday 13th June, 2022 - Saturday 25,h June, 2022 </td><td>2nd</td><td>Second Semester Exams 200 - 500 Level </td></tr>
                    <tr><td>Monday 27,h June, 2022 - Saturday 6lh August, 2022 </td><td>2nd</td><td>SWEP/Field Trip (6 weeks)</td></tr>
                    <tr><td>Monday 27th June, 2022 </td><td>2nd</td><td>Second Semester Break Begins </td></tr>
                    <tr><td>Wednesday 31st August, 2022</td><td>2nd</td><td> School Boards to Consider Second Semester Results </td></tr>
                    <tr><td>Wednesday 31st August, 2022</td><td>2nd</td><td>Senate to Consider Second Semester Results </td></tr>
				</tbody>
			</table>
            </div>
        </div>
    )
}

export default SchoolCalender
